/** One row of core's unmatched-biomarker table (GET /profile/{user_ref}/unmatched):
 *  a name read from a document that no canonical biomarker matched. */
export type UnmatchedStatus = 'pending' | 'auto_mapped' | 'mapped' | 'dismissed';

export type UnmatchedBiomarker = {
  id: number;
  found_name: string;
  domain: string;
  user_ref: string;
  status: UnmatchedStatus | string;
  suggested_canonical: string | null;
  confidence: number | null;
  reasoning: string | null;
  created_at: string;
  resolved_at: string | null;
  resolved_by: string | null;
};

/** Counts as the legacy queue showed them: auto-mapped and mapped are both resolved. */
export function unmatchedCounts(items: UnmatchedBiomarker[]): { pending: number; resolved: number; dismissed: number } {
  let pending = 0; let resolved = 0; let dismissed = 0;
  for (const i of items) {
    if (i.status === 'pending') pending += 1;
    else if (i.status === 'dismissed') dismissed += 1;
    else resolved += 1;
  }
  return { pending, resolved, dismissed };
}

/** The rows to show: pending only, unless the history is on. */
export function visibleUnmatched(items: UnmatchedBiomarker[], history: boolean): UnmatchedBiomarker[] {
  return history ? items : items.filter((i) => i.status === 'pending');
}
